import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { spacing, themeMode, palette } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import styled from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';
import { DropdownMenu } from '../DropdownMenu/DropdownMenu.es.js';
import { Badge } from '../Badge/Badge.es.js';
import { Checkbox } from '../Checkbox/Checkbox.es.js';

const Item = styled(DropdownMenu.Item)``;
const Footer = styled(Box)`
    bottom: 0px;
    overflow: hidden;
    height: 52px;
    margin-bottom: -${spacing("xxs")};
`;
const FilterDropdownBadge = styled(Badge)`
    background-color: ${themeMode({ light: palette("neutral.1000"), dark: palette("neutral.50") })};
    color: ${themeMode({ light: palette("neutral.50"), dark: palette("neutral.900") })};
`;
const FilterDropdownCheckbox = styled(Checkbox)`
    pointer-events: none;
`;

export { FilterDropdownBadge, FilterDropdownCheckbox, Footer, Item };
//# sourceMappingURL=styled.es.js.map
